import SimpleReactValidator from "simple-react-validator";

class CustomReactValidator extends SimpleReactValidator {
    constructor(options = {}) {
        super(options);

        // Override the message helper to customize error messages, particularly for the 'required' rule
        this.helpers.message = (rule, field, options, rules) => {
            if (rule == "required") {
                return field;
            }

            // console.log(options, this.messages);

            // let message = options?.messages?[rule] || options?.messages?.default || this.messages?[rule] || this.messages?.default || rules[rule]?.message;
            let message =
                options?.messages?.[rule] ||
                options?.messages?.default ||
                this.messages?.[rule] ||
                this.messages?.default ||
                rules[rule]?.message;

            // Custom formatting
            // message = message.replace(/^The\s+/i, ''); // Remove "The" from the beginning
            // message = message.replace(/field is required\.\s*$/i, ''); // Remove "field is required." from the end
            // console.log(rule, field, options, rules);

            return message.replace(
                ":attribute",
                this.helpers.humanizeFieldName(field)
            );
        };
    }
}

export default CustomReactValidator;
